import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { LegalFormDto } from '@/modules/counterparty/dto/legal-form.dto.ts';
import Api from '@/modules/core/api/api.ts';
import { LegalFormEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import { LegalFormAdapter } from '@/modules/counterparty/adapters/legal-form.adapter.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';

export class LegalFormApi {
  static async getList(signal?: AbortSignal) {
    const response: ItemsDto<LegalFormDto> = await Api.post(
      LegalFormEndPoint.GetList,
      RequestUtil.orderBy('ПФ', Direction.Asc),
      signal
    );
    return LegalFormAdapter.mapList(response);
  }
}
